import api from "./api";

const get = (userId) => {
  return api.get("/api/user-form-permission/get", { params: { userId } });
};

const getMany = (userIds) => {
  return api.post("/api/user-form-permission/get_many", { userIds });
};

const set = (userId, isFormEnabled) => {
  return api.post("/api/user-form-permission/set", { userId, isFormEnabled });
};

const setTimeOff = (userId, isTimeOffEnabled) => {
  return api.post("/api/user-form-permission/set_time_off", { userId, isTimeOffEnabled });
};

const UserFormPermissionService = {
  get,
  getMany,
  set,
  setTimeOff,
};

export default UserFormPermissionService;
